(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    

	$('.main-cart .quantity button').click(function() {

		var plus = $(this).hasClass('plus');
		var minus = $(this).hasClass('minus');
		var index = $(this).attr('data');
		var quantity = parseInt($('.qty_' + index).val());

		if(plus == true) {
			quantity += 1;
		} else if(minus == true) {
			if(quantity > 0) {
				quantity -= 1;
			}
		}
		$('.qty_' + index).val(quantity);
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-faq"] && !Shopify.designMode) return;
  try {
    

  $('button.question').click(function() {
    var handle = $(this).attr('data');
    $('.answer-'+handle).slideToggle(150);
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_footer"]) return;
  try {
    

  // subnavigation
  $('footer nav button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('footer .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_header"]) return;
  try {
    

  // display desktop sub navigation
  $('nav.desktop button').click(function() {
    $(this).toggleClass('active');
    var handle = $(this).attr('data');

    $('.subnav').each(function() {
      var state = $(this).css('display');
      var floating_handle = $(this).attr('data');
      if(state == 'block' && floating_handle != handle) {
        $(this).slideUp(150);
        $('button.primary_' + floating_handle).toggleClass('active');
      }
    })

    $('.subnav-' + handle).slideToggle(150);
  });

  // display mobile menu
  $('.navicon button').click(function() {
    var scrollTop = $(window).scrollTop();
    
    $('body').addClass('overlay-active').css('top', -scrollTop + 'px');
    $('.nav_mobile_overlay').toggleClass('active');
    $('header nav.mobile').toggleClass('active');
  });

  // hide mobile menu
  $('.nav_mobile_overlay button.close').click(function() {
    var scrollTop = $('body').css('top');
    
    $('.nav_mobile_overlay').toggleClass('active');
    $('header nav.mobile').toggleClass('active');
    $('body').removeClass('overlay-active').css('top', '');
    
    // Restore scroll position
    if (scrollTop) {
      $(window).scrollTop(Math.abs(parseInt(scrollTop)));
    }
  });

  // mobile subnavigation
  $('header nav.mobile button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('header .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();
})();
